import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _cellOnChangeHandlers, _ACTION_HANDLERS;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _isFunction from 'lodash/isFunction';
import _get from 'lodash/get';
import _omit from 'lodash/omit';
import _isEmpty from 'lodash/isEmpty';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _castArray from 'lodash/castArray';
import _reduce from 'lodash/reduce';
import _last from 'lodash/last';
import SORT_ORDER_KEY from '@tekion/tekion-base/constants/sortOrder';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import TABLE_ACTION_TYPES from '../../molecules/tableInputField/constants/TableInputField.actionTypes';
import { REMOVE_ACTION } from '../../molecules/tableInputField/constants/general';
import FORM_PAGE_ACTION_TYPES from '../../pages/formPage/constants/actionTypes';
import FORM_ACTION_TYPES from '../FormBuilder/constants/actionTypes';
import { FIELD_NAMES, FIELD_IDS } from './multiSort.constants';
import { INIT_FORM, RESET_FORM_FIELDS } from './multiSort.actions';
import { getRowIndex } from './multiSort.helpers';
var onFormInit = function onFormInit(payload) {
  var getState = payload.getState,
    setState = payload.setState;
  var _getState = getState(),
    sortDetails = _getState.sortDetails;
  var initialSortPreferences = [].concat(_toConsumableArray(_map(_keys(sortDetails), function (key) {
    var _ref;
    return _ref = {}, _defineProperty(_ref, FIELD_IDS.SORT_FIELD, _castArray(key)), _defineProperty(_ref, FIELD_IDS.SORT_ORDER, sortDetails[key]), _ref;
  })), [{
    isLastRow: true
  }]);
  setState({
    values: _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, initialSortPreferences),
    initialSortPreferences: initialSortPreferences
  });
};
var handleDeleteRowAction = function handleDeleteRowAction(_ref2) {
  var getState = _ref2.getState,
    _ref2$params = _ref2.params,
    params = _ref2$params === void 0 ? EMPTY_OBJECT : _ref2$params,
    setState = _ref2.setState;
  if (params.actionType !== REMOVE_ACTION.id) return;
  var _getState2 = getState(),
    values = _getState2.values;
  var sortPreferences = _get(values, FIELD_NAMES.SORT_PREFERENCES);
  var index = getRowIndex(params);
  if (!_isEmpty(sortPreferences[index])) {
    setState({
      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, [].concat(_toConsumableArray(sortPreferences.slice(0, index)), _toConsumableArray(sortPreferences.slice(index + 1)))))
    });
  }
};
var sortFieldChangeHandler = function sortFieldChangeHandler() {
  var _sortPreferences$inde, _objectSpread3;
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
    setState = _ref3.setState,
    getState = _ref3.getState,
    params = _ref3.params;
  var sortFieldSelected = _get(params, 'value');
  var index = getRowIndex(params);
  var _getState3 = getState(),
    values = _getState3.values;
  var sortPreferences = _get(values, FIELD_NAMES.SORT_PREFERENCES);
  var isLastRow = ((_sortPreferences$inde = sortPreferences[index]) === null || _sortPreferences$inde === void 0 ? void 0 : _sortPreferences$inde.isLastRow) || false;
  setState({
    values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, [].concat(_toConsumableArray(sortPreferences.slice(0, index)), [_objectSpread(_objectSpread({}, _omit(sortPreferences[index], ['isLastRow'])), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, FIELD_IDS.SORT_FIELD, sortFieldSelected), _defineProperty(_objectSpread3, FIELD_IDS.SORT_ORDER, SORT_ORDER_KEY.ASC), _objectSpread3))], _toConsumableArray(sortPreferences.slice(index + 1)), _toConsumableArray(isLastRow ? [{
      isLastRow: true
    }] : []))))
  });
};
var sortOrderChangeHandler = function sortOrderChangeHandler() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
    setState = _ref4.setState,
    getState = _ref4.getState,
    params = _ref4.params;
  var sortOrderSelected = _get(params, 'params.value');
  var index = getRowIndex(params);
  var _getState4 = getState(),
    values = _getState4.values;
  var sortPreferences = _get(values, FIELD_NAMES.SORT_PREFERENCES);
  setState({
    values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, [].concat(_toConsumableArray(sortPreferences.slice(0, index)), [_objectSpread(_objectSpread({}, sortPreferences[index]), {}, _defineProperty({}, FIELD_IDS.SORT_ORDER, sortOrderSelected))], _toConsumableArray(sortPreferences.slice(index + 1)))))
  });
};
var cellOnChangeHandlers = (_cellOnChangeHandlers = {}, _defineProperty(_cellOnChangeHandlers, FIELD_IDS.SORT_FIELD, sortFieldChangeHandler), _defineProperty(_cellOnChangeHandlers, FIELD_IDS.SORT_ORDER, sortOrderChangeHandler), _cellOnChangeHandlers);
var reArrangeSortPreferences = function reArrangeSortPreferences(payload) {
  var setState = payload.setState,
    params = payload.params;
  var sortPreferences = _get(params, 'value', []);
  setState({
    values: _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, sortPreferences)
  });
};
var handleTableFieldOnChange = function handleTableFieldOnChange(params) {
  var _params$params = params.params,
    _params$params2 = _params$params === void 0 ? EMPTY_OBJECT : _params$params,
    columnId = _params$params2.columnId;
  var funcToExec = cellOnChangeHandlers[columnId];
  if (!_isFunction(funcToExec)) {
    reArrangeSortPreferences(params);
    return;
  }
  funcToExec(params);
};
export var TABLE_ACTION_HANDLERS = _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, handleTableFieldOnChange);
var fieldOnChangeHandlers = _objectSpread({}, TABLE_ACTION_HANDLERS);
var onFieldChange = function onFieldChange(_ref5) {
  var getState = _ref5.getState,
    setState = _ref5.setState,
    _ref5$params = _ref5.params,
    params = _ref5$params === void 0 ? EMPTY_OBJECT : _ref5$params;
  var handler = fieldOnChangeHandlers[params.id];
  handler({
    getState: getState,
    setState: setState,
    params: params
  });
};
var handleSubmit = function handleSubmit(_ref6) {
  var getState = _ref6.getState;
  var _getState5 = getState(),
    onSortApply = _getState5.onSortApply,
    values = _getState5.values;
  var sortPreferences = _get(values, FIELD_NAMES.SORT_PREFERENCES);
  var sortTypeMap = _reduce(sortPreferences, function (acc, sortPreference) {
    if (sortPreference.isLastRow) return acc;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, sortPreference[FIELD_IDS.SORT_FIELD], sortPreference[FIELD_IDS.SORT_ORDER]));
  }, {});
  onSortApply(sortTypeMap);
};
var handleReset = function handleReset(_ref7) {
  var setState = _ref7.setState;
  setState(function (_ref8) {
    var values = _ref8.values;
    return {
      values: _defineProperty({}, FIELD_NAMES.SORT_PREFERENCES, [_last(values[FIELD_NAMES.SORT_PREFERENCES])])
    };
  });
};
export var ACTION_HANDLERS = (_ACTION_HANDLERS = {}, _defineProperty(_ACTION_HANDLERS, INIT_FORM, onFormInit), _defineProperty(_ACTION_HANDLERS, FORM_ACTION_TYPES.ON_FIELD_CHANGE, onFieldChange), _defineProperty(_ACTION_HANDLERS, TABLE_ACTION_TYPES.TABLE_ACTION_CLICK, handleDeleteRowAction), _defineProperty(_ACTION_HANDLERS, FORM_PAGE_ACTION_TYPES.ON_FORM_SUBMIT, handleSubmit), _defineProperty(_ACTION_HANDLERS, RESET_FORM_FIELDS, handleReset), _ACTION_HANDLERS);